import React from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Tooltip } from 'antd'

import '../../../assets/index.scss'

const ClickableIcon = ({ className = '', color, disabled = false, icon, size = 'default', title = '', type = 'default', onClick }) => {
  const localClassName = 'clickable-icon' + (className ? ` ${className}` : '')

  return (
    <Tooltip
      title={title}
    >
      <Button
        className={localClassName}
        disabled={disabled}
        size={size}
        type={type}
        onClick={onClick}
      >
        <FontAwesomeIcon icon={icon} color={color} />
      </Button>
    </Tooltip>
  )
}

export default ClickableIcon
